import {
  VuexModule,
  Module,
  getModule,
  Mutation,
  Action
} from "vuex-module-decorators";
import store from "@/general/store";
import Cookies from "js-cookie";
import { UserInfo } from "@/general/store/models";
import { initialUnencryptedStorage } from "./configs";

export interface AuthState {
  user: UserInfo;
  authenticate: boolean;
  lastUserOperationDate: string | null;
  subscriptions: string | null;
  ssoPrincipalFlg: string | boolean;
}

@Module({
  name: "auth",
  store: store,
  namespaced: true,
  dynamic: true,
  preserveState: Boolean(initialUnencryptedStorage["auth"])
})
class AuthModule extends VuexModule {
  user = {} as UserInfo;
  authenticate = false;
  lastUserOperationDate = null;
  subscriptions = "";
  ssoPrincipalFlg = "1";

  get isLoggedIn() {
    return Boolean(this.user);
  }

  get ssoPrincipal() {
    return Boolean(this.ssoPrincipalFlg);
  }

  @Mutation
  removeUser() {
    this.user = {} as UserInfo;
  }

  @Mutation
  setLastUserOperationDate(state: AuthState, payload: string) {
    state.lastUserOperationDate = payload;
  }

  @Mutation
  setSsoPrincipalFlg(state: AuthState, payload: string) {
    console.log(state);
    console.log(payload);
    state.ssoPrincipalFlg = payload;
  }

  @Mutation
  set({
    user,
    authenticate,
    subscriptions
  }: {
    user: UserInfo;
    authenticate: boolean;
    subscriptions: string;
  }) {
    if (user) {
      this.user = user;
    }
    if (authenticate) {
      this.authenticate = authenticate;
    } else {
      this.authenticate = false;
    }
    if (subscriptions) {
      this.subscriptions = subscriptions;
    }
  }

  @Action({ rawError: true })
  remove() {
    this.context.commit("removeUser");
    // ThemiStruct ログアウト
    // const sdk = new IPSDK("https", process.env.VUE_APP_LOGIN_API_FQDN, "443");
    try {
      // sdk.signout("POST");
    } catch (e) {
      console.log(e);
    }

    Cookies.remove(process.env.VUE_APP_COOKIE_NAME as string, {
      domain: process.env.VUE_APP_COOKIE_DOMAIN,
      path: "/",
      secure: true
    });
  }

  @Action({ rawError: true })
  init(payload: AuthState) {
    if (payload.user) {
      // auth.user = payload.user;
    }
    if (payload.subscriptions) {
      this.context.commit("set", { subscriptions: payload.subscriptions });
    }
  }

  @Action({ rawError: true })
  initSubscription(user: UserInfo, subscriptions: string) {
    // if (user) {
    //   this.context.commit("set", { user: user });
    // }
    if (subscriptions) {
      this.context.commit("set", { subscriptions: subscriptions });
    }
  }

  @Action({ rawError: true })
  setUser(payload: AuthState) {
    this.context.commit("set", { user: payload.user });
  }

  @Action({ rawError: true })
  setAuthentication(payload: AuthState) {
    this.context.commit("set", { authenticate: payload.authenticate });
  }
}

export default getModule(AuthModule);
